import closeAllMenus from '../../core/INF-closeAllMenus';
import adjustPositioning from './adjustPositioning';

export default function (e) {
  let modal;
  let hash;

  if (e.preventDefault) {
    e.preventDefault();

    // Get modal from data attr first
    const openModalSelector = e.target.dataset.openModal;
    if (openModalSelector) {
      modal = document.querySelector(openModalSelector);
    }

    // Check href next if no modal found from data attribute
    if (!modal) {
      hash = e.target.getAttribute('href');
      if (hash) {
        modal = document.querySelector(hash);
      }
    }

    // Still no modal? Nothing to do
    if (!modal) {
      return false;
    }
  } else {
    // This isn't an event, we're passing a modal manually as "e"
    modal = e;
  }

  closeAllMenus();

  adjustPositioning(modal);
  document.querySelectorAll('[data-state]').forEach((el) => el.classList.add('State--modal-open'));
  modal.classList.add('Modal--open');

  if (hash) {
    if (e.target.dataset.openModal === '') {
      window.location.hash = '';
    } else {
      window.location.hash = hash;
    }
  }

  document.dispatchEvent(new Event('scroll'));
  const modalDidOpenEvent = new CustomEvent('modalDidOpen', { detail: modal });
  return document.dispatchEvent(modalDidOpenEvent);
}
